import { ProcessingTypeStatus } from '@features/siteStatusV2/constants/report';

const MapProcesssingTypeStatusToDisplay: Record<ProcessingTypeStatus, string> = {
  [ProcessingTypeStatus.NETWORK_DAMAGE]: 'report.processingType.networkDamage',
  [ProcessingTypeStatus.COVID_ClIENT]: '-',
  [ProcessingTypeStatus.COVID_UP]: '-',
  [ProcessingTypeStatus.ESC]: 'report.processingType.esc',
  [ProcessingTypeStatus.IG]: 'report.processingType.ig',
  [ProcessingTypeStatus.OBS]: 'report.processingType.obs',
  [ProcessingTypeStatus.SAV]: 'report.processingType.sav',
  [ProcessingTypeStatus.SAV_CLOT]: 'report.processingType.savClot',
  [ProcessingTypeStatus.WISP]: 'report.processingType.wisp',
  [ProcessingTypeStatus.NO_STATUS]: '-'
};

export default MapProcesssingTypeStatusToDisplay;
